import { DashboardState, IFiltroLocal, IItemsProperties, ILayout, Widgets } from './types';
import { IDocumentos, IEmpresas } from '@/types';

export const createCard = ({ label, reference, isMax, x, y, i }: IItemsProperties) => ({
  agruparPor: 'Dia',
  h: 4,
  i,
  label,
  maxH: 4,
  maxW: 12,
  minH: 4,
  minW: 6,
  moved: false,
  reference,
  static: false,
  tipo: Widgets.card,
  w: isMax ? 12 : 6,
  x: x,
  y: y
});

export const createChart = ({ label, reference, isMax, x, y, i, agruparPor = '' }: IItemsProperties) => ({
  agruparPor,
  h: 12,
  i,
  label,
  maxH: 12,
  maxW: 24,
  minH: 12,
  minW: 12,
  moved: false,
  reference,
  static: false,
  tipo: Widgets.chart,
  w: isMax ? 24 : 12,
  x: x,
  y: y
});

export const createTable = ({ label, reference, isMax, x, y, i, agruparPor = '' }: IItemsProperties) => ({
  agruparPor,
  h: 12,
  i,
  label,
  maxH: 12,
  maxW: 24,
  minH: 12,
  minW: 12,
  moved: false,
  reference,
  static: false,
  tipo: Widgets.table,
  w: isMax ? 24 : 12,
  x: x,
  y: y
});

export const Dashboard: DashboardState = {
  dashboardList: [],
  currentDash: '',
  currentDashboardName: '',
  isEditorMode: false,
  isEditar: false,
  shotcutDate: {
    paramsEnvio: {}
  },
  gridLayoutEditor: [] as ILayout[],
  empresasOptions: [] as IEmpresas[],
  tipoDeDocumento: [] as IDocumentos[],
  filtrosLocaisPreenchidos: [] as IFiltroLocal[]
};
